<template>
    <b-card class="block__objectiveListProduction">
      <header>
        <!-- TITLE -->
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>          
            {{datalists.name}}
          </PuSkeleton>
          </p>
        <!-- TITLE -->
      </header>

      <b-list-group>
        <b-list-group-item v-for="(list,index) of datalists.underCategories" :key="index">

          <!-- SUBCHILD TITLE -->
          <div class="entete">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>                
              <div class="title">
                  {{list.name}}
                <div class="icon" v-if="list.underCategorieQualificatif" :class="isPostive(list.value,list.qualificatifValue)">
                  <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                </div>
              </div>
            </PuSkeleton>
            <PuSkeleton :loading="isLoading" :count="1" width='20px'>
              <div class="number" v-if="list.value != null">{{Math.round(Math.floor(list.value)).toLocaleString()}}</div>
            </PuSkeleton>
          </div>
          <!-- SUBCHILD TITLE -->


          <!-- SUBCHILD -->
          <div class="label" v-for="(subChild,index) in list.data" :key="index">

            <div class="left">

              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <div class="title">
                  {{subChild.name}}
                  <span v-if="subChild.secondValue !== 'undefined' && subChild.secondValue !== null">
                    sans CM
                  </span>
                  <div class="icon" v-if="subChild.dataQualificatif" :class="isPostive(subChild.firstValue,subChild.qualificatifValue)">
                    <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                  </div>
                </div>                      
                <span v-if="subChild.firstValue != null">{{Math.round(Math.floor(subChild.firstValue)).toLocaleString()}}</span>
                <span v-if="subChild.firstValue != null">{{subChild.firstValueType}}</span>
              </PuSkeleton>
 
              <PuSkeleton :loading="isLoading" :count="1" width='160px' v-if="subChild.secondValue !== 'undefined' && subChild.secondValue !== null">
                <div class="title">
                  {{subChild.name}} avec CM
                  <div class="icon" v-if="subChild.dataQualificatif" :class="isPostive(subChild.secondValue,subChild.qualificatifValue)">
                    <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                  </div>                  
                </div>                      
                <span v-if="subChild.secondValue != null">{{Math.round(Math.floor(subChild.secondValue)).toLocaleString()}}</span>
                <span v-if="subChild.secondValue != null">{{subChild.secondValueType}}</span>
              </PuSkeleton>
            
            </div>
            <div class="right">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <span v-if="subChild.firstPointValue != null">{{Math.round(Math.floor(subChild.firstPointValue)).toLocaleString()}}</span>
                <span v-if="subChild.firstPointValue != null">{{subChild.firstPointValueType}}</span>
              </PuSkeleton>
              <PuSkeleton :loading="isLoading" :count="1" width='160px' v-if="subChild.secondValue !== 'undefined'">
                <span v-if="subChild.secondPointValue != null">{{Math.round(Math.floor(subChild.secondPointValue)).toLocaleString()}}</span>
                <span v-if="subChild.secondPointValue != null">{{subChild.secondPointValueType}}</span>
              </PuSkeleton>
            </div>

            <!-- <div class="result" v-if="subChild.valueStrongSub">
              <PuSkeleton :loading="isLoading" :count="1" width='20px'>
                {{subChild.valueStrongSub}} 
              </PuSkeleton>
            </div> -->

          </div>
          <!-- SUBCHILD -->


        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>

export default {
name:"wrapperObjectiveListProductions",
  props:{
    lists:{
      type:[Object],
      default: () => {
        return {}
        }
      },
    isLoad:{
      default: true
    }
  },
  data(){
    return {
      isLoading:true,
      datalists: { 
          name:'Production',
          underCategories:[{},{}],
          value:'50' 
        }
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.datalists = this.lists;
  },  
  methods:{
    isPostive(value,qualificatifValue = 0){
      return qualificatifValue <= value ?  'green' : 'red';
    }
  },
  watch : {
    'isLoad' : function (){
      this.datalists = this.lists;  
      this.isLoading = this.isLoad;
    },    
  },     
}
</script>
